import intentToUrl from './intentToUrl';
import intentObjToUrl from './intentObjToUrl';
export { intentToUrl as default, intentToUrl, intentObjToUrl };


// WEBPACK FOOTER //
// ../node_modules/@cube/intent-to-url/src/index.js